module.exports = __webpack_public_path__ + "static/img/cont37_06.049936b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont37_06.jpg
// module id = 3PDv
// module chunks = 0